import React from "react";
import { Home, Compass } from "lucide-react";

const AnalysisModeToggle = ({
    analysisMode,
    setAnalysisMode,
    isLoading,
    address,
    primaryAddress,
    setAddress,
    setPrimaryAddress,
    setMergedLots,
    setNeighbourProperties
}) => {
    return (
        <div className="flex flex-col gap-2 bg-slate-50/40 p-3 rounded-2xl border border-slate-200">
            <label className="text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                Analysis Mode
            </label>
            <div className="p-1 bg-slate-200/60 rounded-xl flex border border-slate-200/20">
                <button
                    type="button"
                    disabled={isLoading}
                    onClick={() => {
                        setAnalysisMode("single");
                        if (primaryAddress) {
                            setAddress(primaryAddress);
                        }
                        setMergedLots([]);
                        setNeighbourProperties([]);
                    }}
                    className={`flex-1 py-2 px-3 rounded-lg text-xs font-bold transition-all flex items-center justify-center gap-2 ${analysisMode === "single"
                            ? "bg-white text-slate-900 shadow-sm border border-slate-200/40"
                            : "text-slate-500 hover:text-slate-800"
                        }`}
                >
                    <Home className="w-3.5 h-3.5" />
                    Single Parcel Mode
                </button>
                <button
                    type="button"
                    disabled={isLoading}
                    onClick={() => {
                        setAnalysisMode("merged");
                        if (address && !primaryAddress) {
                            setPrimaryAddress(address);
                            setAddress("");
                        } else if (primaryAddress) {
                            setAddress(""); // Clear search input to allow searching for next lot to merge
                        }
                    }}
                    className={`flex-1 py-2 px-3 rounded-lg text-xs font-bold transition-all flex items-center justify-center gap-2 ${analysisMode === "merged"
                            ? "bg-blue-600 text-white shadow-sm border border-blue-500"
                            : "text-slate-500 hover:text-slate-800"
                        }`}
                >
                    <Compass className="w-3.5 h-3.5" />
                    Combined Lots Mode
                </button>
            </div>
        </div>
    );
};

export default AnalysisModeToggle;
